import { render, staticRenderFns } from "./naverReturn.vue?vue&type=template&id=670c3ea6&scoped=true"
import script from "./naverReturn.vue?vue&type=script&lang=js"
export * from "./naverReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c3ea6",
  null
  
)

export default component.exports